<script>
  import { writable } from "svelte/store";

  import PostcodeMapChecker from "./components/PostcodeMapChecker.svelte";
  import NoPractice from "./components/NoPractice.svelte";

  export let practices;
  export let practice = { name: "" };

  let postcode = "";

  const status = writable();
</script>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :global(a),
  :global(a:hover),
  :global(a:visited) {
    color: white;
    text-decoration: underline;
  }

  .main {
    width: 100%;
    height: 100%;

    display: grid;
    grid-template-rows: auto 1fr;
  }

  section {
    padding: 1rem;
  }

  .controls {
    background-color: royalblue;
    color: white;
  }

  .credit {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
</style>

<svelte:head>
  <title>{practice.name || ''} Catchment Area Checker</title>
</svelte:head>
{#if practice.name === ''}
  <NoPractice {practices} />
{:else}
  <div class="main">
    <section class="controls">

      <h1>{practice.name} Catchment Area Checker</h1>
      Postcode:
      <input type="text" bind:value={postcode} />

      <br />

      <span class="status">{$status}</span>

      <span class="credit">
        by
        <a href="https://ibraheemrodrigues.com">Ibraheem Rodrigues</a>
      </span>

    </section>

    <PostcodeMapChecker {practice} {postcode} {status} />
  </div>
{/if}
